import Image from 'components/Common/Image'
import AspectRatio from 'components/utils/AspectRatio'
import { mediaQueryUp } from 'components/utils/breakpoint'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const PhotoCardContainer = styled(Group)`
  ${mediaQueryUp.desktop} {
    min-width: ${rem(480)};
  }

  ${mediaQueryUp.largeDesktop} {
    min-width: ${rem(600)};
    padding-bottom: ${rem(34)};
  }
`

const PhotoCard = styled.div`
  width: ${rem(122)};
  height: ${rem(167)};
  border-radius: ${props => props.theme.borderRadius.S};
  overflow: hidden;
  border: 2px solid ${props => props.theme.palette.neutral.surface.normalBackground};
  box-shadow: ${props => props.theme.shadow.bottom.large};

  &.rotate-negative {
    transform: rotate(-10deg);
  }
  &.rotate-positive {
    transform: translateY(${rem(32)}) rotate(10deg);
  }

  ${mediaQueryUp.tablet} {
    width: ${rem(146)};
    height: ${rem(200)};
    border-radius: ${props => props.theme.borderRadius.L};
  }

  ${mediaQueryUp.desktop} {
    width: ${rem(176)};
    height: ${rem(240)};
  }

  ${mediaQueryUp.largeDesktop} {
    width: ${rem(220)};
    height: ${rem(300)};
    border-width: 3px;
  }
`

interface Props {
  photoIds?: Array<string | null>
}

function WeddingPhotoCardsStack({ photoIds }: Props) {
  const intl = useIntl()
  const validIds = photoIds?.filter((id): id is string => Boolean(id)) ?? []
  const photo1 = validIds[0]
  const photo2 = validIds[1]

  return (
    <PhotoCardContainer direction="horizontal" gap={0} horizontalAlign="center">
      <PhotoCard className="rotate-negative">
        <AspectRatio ratio="11:15">
          <Image
            id={photo1}
            alt={intl.formatMessage({ defaultMessage: 'Wedding Photo', id: 'Ufe68AAA7KDFs2ZcMbDR', description: 'Alt text for a decorative wedding greeting photo card.' })}
            objectFit="cover"
            fit="center"
          />
        </AspectRatio>
      </PhotoCard>
      <PhotoCard className="rotate-positive">
        <AspectRatio ratio="11:15">
          <Image
            id={photo2}
            alt={intl.formatMessage({ defaultMessage: 'Wedding Photo', id: 'Ufe68AAA7KDFs2ZcMbDR', description: 'Alt text for a decorative wedding greeting photo card.' })}
            objectFit="cover"
            fit="center"
          />
        </AspectRatio>
      </PhotoCard>
    </PhotoCardContainer>
  )
}

export default WeddingPhotoCardsStack
